import React from 'react';
import PoweredByEvaa from '../assets/poweredByEvaa';

export default function Footer() {
	return (
		<footer 
			className="hidden sm:block fixed bottom-0 right-0 z-10 p-2 px-6"
		>
			<PoweredByEvaa 
				className="h-6 sm:h-8 md:h-10 w-auto" 
				style={{ color: 'color-mix(in srgb, var(--color-primary) 50%, white)' }}
			/>
		</footer>
	);
}